import "./style.scss";

import React, { FC } from "react";

import { ReactComponent as IconChecked } from "assets/img/icons/icon_status-Checked.svg";
import { ReactComponent as IconError } from "assets/img/icons/icon_Error.svg";
import { ReactComponent as IconInfo } from "assets/img/icons/icon_Info.svg";
import { ReactComponent as IconWarning } from "assets/img/icons/icon_Warning.svg";

type AlertType = {
    type: "error" | "success" | "warning" | "info";
    showDefaultIcon?: boolean;
    children: React.ReactNode;
};
//
const Alert: FC<AlertType> = ({
    type,
    showDefaultIcon = true,
    children
}) => {
    const iconMap = {
        error: (
            <IconError
                width="16px"
                fill="#FF5326"
                className="flex-none"
            />
        ),
        success: (
            <IconChecked
                width="16px"
                fill="#17EB79"
                className="flex-none"
            />
        ),
        warning: (
            <IconWarning
                width="16px"
                fill="#FF8833"
                className="flex-none"
            />
        ),
        info: (
            <IconInfo
                width="16px"
                fill="#1956A8"
                className="flex-none"
            />
        ),
        none: (
            <div></div>
        ),

    };

    const icon = iconMap[type] || (
        <IconInfo
            width="16px"
            fill="#1956A8"
            className="flex-none"
        />
    );

    return (
        <div className={`alert-component alert-component-${type}`}>
            {showDefaultIcon? icon : null}
            <div className="alert-component__content font-M">{children}</div>
        </div>
    );
};

export default Alert;
